/* eslint-disable react/prop-types */
import { useCallback, useState } from "react";
import ProjectContainer from "../../../project/container/project.container";
import {
  useGetAnOrganizationQuery
} from "../../api/orgApiSlice";
import { OrganizationItemContainerProps } from "../../types/types";
import OrganizationAddContainer from "../OrganizationAddContainer";
import OrganizationDetailsActionContainer from "./Organization.details.action.container/organization.details.action.container";
const OrganizationDetailsMainContainer: React.FC<
  OrganizationItemContainerProps
> = ({ organizationId }) => {
  const {
    data: organization,
    // isLoading,
    isSuccess,
    isError,
    error: orgError
  } = useGetAnOrganizationQuery(organizationId)

  const [openStatusAddDisplay, setOpenStatusAddDisplay] =
    useState<boolean>(false)

  const handleClose = useCallback(
    () => { setOpenStatusAddDisplay(false) },
    [openStatusAddDisplay]
  )

  const handleOpen = useCallback(
    () => { setOpenStatusAddDisplay(true) },
    [openStatusAddDisplay]
  )
  return (
    <>
      {isSuccess && (
        <>
          <OrganizationDetailsActionContainer
            organization={organization.entities[organizationId]}
            handleOpen={handleOpen}
          />
          <OrganizationAddContainer
            openStatusAddDisplay={openStatusAddDisplay}
            handleClose={handleClose}
            status="EDIT"
            organization={organization.entities[organizationId]}
          />
          <ProjectContainer
            organization={organization.entities[organizationId]!}
          />
        </>
      )}
      {isError && <h1>{'something went wrong ggggg'}</h1>}
    </>
  )
}

export default OrganizationDetailsMainContainer
